'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIFixedSaveBar;

var _theme = require('HubStyleTokens/theme');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIAbstractPageSection = require('../page/UIAbstractPageSection');

var _UIAbstractPageSection2 = _interopRequireDefault(_UIAbstractPageSection);

var _Styles = require('../utils/Styles');

var _UIStickyFooter = require('./UIStickyFooter');

var _UIStickyFooter2 = _interopRequireDefault(_UIStickyFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StickyFooter = (0, _styledComponents2.default)(_UIStickyFooter2.default).withConfig({
  displayName: 'UIFixedSaveBar__StickyFooter'
})(['&&{background-color:', ';border-top:1px solid ', ';box-shadow:none;padding-bottom:20px;padding-top:20px;}'], _theme.PANEL_FOOTER_BACKGROUND_COLOR, _theme.PANEL_FOOTER_BORDER_COLOR);

var PageSection = (0, _styledComponents2.default)(_UIAbstractPageSection2.default).withConfig({
  displayName: 'UIFixedSaveBar__PageSection'
})(['.space-sword--max-width &{', '}'], (0, _Styles.setTemplateMaxWidth)());

function UIFixedSaveBar(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, ['children']);

  return _react2.default.createElement(
    StickyFooter,
    rest,
    _react2.default.createElement(
      PageSection,
      null,
      children
    )
  );
}

UIFixedSaveBar.propTypes = _UIStickyFooter2.default.propTypes;
UIFixedSaveBar.defaultProps = _UIStickyFooter2.default.defaultProps;
UIFixedSaveBar.displayName = 'UIFixedSaveBar';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/panel/UIFixedSaveBar.js
// module id = 589
// module chunks = 177